import React from 'react';
import { useQuery } from 'react-fetching-library';
import Page from '../../components/Page';
import { Card, CardContent, Tab, Tabs } from '@mui/material';
import AddTemplate from '../../sections/employee/templates/AddTemplate';
import AgreementTemplateList from '../../sections/employee/templates/AgreementTemplateList';
import { InvoiceTemplates } from '../../sections/employee/templates/InvoiceTemplates';
import { DynamicSections } from '../../sections/employee/templates/DynamicSections';

import { getAgreementTemplateAction } from '../../services/request';

export default function AgreementsTemplates() {
  const [search, setSearch] = React.useState(null);
  const { loading, payload, error } = useQuery(
    getAgreementTemplateAction('GET', search)
  );
  const [templates, setTemplates] = React.useState([]);
  const [currentTab, setCurrentTab] = React.useState(0);

  const queryCallback = (searchVal = null) => {
    setSearch(searchVal);
  };

  React.useEffect(() => {
    if (!loading && !error && payload) {
      setTemplates(payload.results ?? []);
    }
  }, [loading]);

  return (
    <Page title="Szablony">
      <Card>
        <CardContent>
          <Tabs
            value={currentTab}
            onChange={(e, value) => setCurrentTab(value)}
          >
            <Tab label="Szablony umów" />
            <Tab label="Szablony faktur" />
            <Tab label="Dynamiczne sekcje" />
          </Tabs>
          {currentTab === 0 ? (
            <>
              <AddTemplate setTemplates={setTemplates} />
              <AgreementTemplateList
                templates={templates}
                queryCallback={queryCallback}
                setTemplates={setTemplates}
              />
            </>
          ) : currentTab === 1 ? (
            <InvoiceTemplates />
          ) : currentTab === 2 ? (
            <DynamicSections />
          ) : null}
        </CardContent>
      </Card>
    </Page>
  );
}
